import {
  AccessorialCode,
  AccessorialCodeWellKnownNaturalId,
} from '@rygen/rygen-ui/model';

export abstract class BaseEditQuoteChargeTableItem {
  id?: number;
  /**
   * Composite key to track accessorial charges (duplicates) - `${indexKey}-${naturalIdKey}`
   */
  key?: string;
  chargeCode?: AccessorialCode;
  stopSequenceNumber?: number;

  protected constructor(opts?: Partial<BaseEditQuoteChargeTableItem>) {
    if (opts?.id != null) {
      this.id = opts.id;
    }
    if (opts?.key != null) {
      this.key = opts.key;
    }
    if (opts?.chargeCode != null) {
      this.chargeCode = new AccessorialCode(opts.chargeCode);
    }
    if (opts?.stopSequenceNumber != null) {
      this.stopSequenceNumber = opts.stopSequenceNumber;
    }
  }

  get chargeNaturalId(): string | undefined {
    return this.chargeCode?.naturalId;
  }

  get hasChargeSelection(): boolean {
    return !!this.chargeCode;
  }

  abstract rateAmount(rateType?: 'buy' | 'margin' | 'sell'): number;

  isLineHaulCharge(): boolean {
    return this.chargeNaturalId === AccessorialCodeWellKnownNaturalId.LINEHAUL;
  }

  isFuelCharge(): boolean {
    return this.chargeNaturalId === AccessorialCodeWellKnownNaturalId.FUEL;
  }

  isFreightCharge(): boolean {
    return this.isLineHaulCharge() || this.isFuelCharge();
  }

  matchesAccessorialById(rateQuoteAccessorialId: number | undefined): boolean {
    // Explicitly check both id's for undefined, as both can be undefined when comparing newly added charges
    if (this.id && rateQuoteAccessorialId) {
      return this.id === rateQuoteAccessorialId;
    }

    return false;
  }
}
